'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = require('../env');

function isRunningInChrome() {
  var userAgentHasChrome = (0, _env.env)() && (0, _env.env)().navigator && (0, _env.env)().navigator.userAgent && (0, _env.env)().navigator.userAgent.match(/Chrome\/([0-9]+)(\.[0-9]+)+/) !== null;
  var userAgentHasChromium = (0, _env.env)() && (0, _env.env)().navigator && (0, _env.env)().navigator.userAgent && (0, _env.env)().navigator.userAgent.match(/Chromium\/([0-9]+)(\.[0-9]+)+/) !== null;

  return userAgentHasChrome && !userAgentHasChromium;
}

/**
 * env().performance wrappers
 */
exports.default = {
  getNavigation: function getNavigation() {
    return typeof (0, _env.env)() !== 'undefined' && (0, _env.env)().performance ? (0, _env.env)().performance.navigation : {};
  },


  /**
   * get all loaded resources
   */
  getResources: function getResources() {
    var emptyVal = [];
    try {
      return (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.getEntriesByType && (0, _env.env)().performance.getEntriesByType('resource') || emptyVal;
    } catch (e) {
      return emptyVal;
    }
  },
  getTiming: function getTiming() {
    return (0, _env.env)() && (0, _env.env)().performance ? (0, _env.env)().performance.timing : {};
  },


  /**
   * Duration relative to navigation start (env().performance.timing.navigationStart)
   * fallback to: performance.now -> now (nodejs) -> getTime()
   */
  now: function now() {
    if ((0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.now) {
      return (0, _env.env)().performance.now();
    } else if (typeof performance !== 'undefined' && performance && performance.now) {
      return performance.now();
    }

    return new Date().getTime();
  },


  /**
   * Create a performance timestamp
   */
  mark: function mark(name) {
    if (isRunningInChrome()) {
      (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.mark && (0, _env.env)().performance.mark(name);
    }
  },


  /**
   * Record a performance measurement
   */
  measure: function measure(name, startMark, endMark) {
    if (isRunningInChrome()) {
      (0, _env.env)() && (0, _env.env)().performance && (0, _env.env)().performance.measure && (0, _env.env)().performance.measure(name, startMark, endMark);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/fedops-logger/dist/src/performance/performance.js
// module id = 53
// module chunks = 0